import SelectOption from '@/models/interface/SelectOption'
import SystemDashboardAction from '@/models/SystemDashboardAction'

/**
 * Filter action for selecting a Company.delivery_goals entry. Rendered by the
 * dedicated `goal-select` branch in DashboardAction.vue, which loads options
 * itself from `companyId` — no cross-component reactivity dance.
 */
export default class GoalPickerAction extends SystemDashboardAction {
  public target: string = 'filters'

  public key: string = 'goal_id'

  public type: string = 'goal-select'

  public label: string = ''

  // Unused by the goal-select branch (DashboardAction loads options itself),
  // kept on the base class for type compatibility.
  public options: SelectOption[] = []

  public allow_empty: boolean = false

  // Source company for the goal list. DashboardAction reads this on mount.
  public companyId: string = ''

  // Render the action in a narrow, right-aligned column when wrapped in
  // eachRightCol. The widget owning this action chooses where to render it.
  public bind: any = {
    cols: '12',
    md: '6',
    lg: '4',
    'offset-md': '6',
    'offset-lg': '8',
  }

  constructor(args: any = null) {
    super()
    if (args && args.companyId) {
      this.companyId = args.companyId
    }
  }
}
